import http from "../http-common";

class EmployeeService {
  // ========== LEAVE MANAGEMENT ==========
  getAllEmployeeLeaves(
    token: any,
    email?: any,
    user?: any,
    month?: any,
    year?: any,
    date?: any,
  ) {
    return http.get(
      `employee/leaves?email=${email}&user=${user}&month=${month}&year=${year}&date=${date}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
  }

  createEmployeeLeave(data: any, token: any) {
    return http.post(`employee/leaves`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  addEditNote(id: string, noteData: any) {
    return http.patch(`/employee/leaves/${id}/note`, noteData);
  }

  deleteNote(id: string) {
    return http.delete(`/employee/leaves/${id}/note`);
  }

  deleteEmployeeLeave(token: any, id: any) {
    return http.delete(`employee/leaves/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  // ========== PROFILE MANAGEMENT ==========
  getAllEmployeeProfiles(token: any, user: string) {
    return http.get(`employee/profile?user=${user}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getEmployeeProfileByEmail(token: any, email: string) {
    return http.get(`employee/profile/${email}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  createEmployeeProfile(token: any, data: any) {
    return http.post(`employee/profile`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateAdminFields(token: any, email: string, data: any, user: string) {
    return http.patch(`employee/profile/admin/${email}?user=${user}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  deleteEmployeeProfile(token: any, email: string, user: string) {
    return http.delete(`employee/profile/${email}?user=${user}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  // ========== ATTENDANCE MANAGEMENT ==========
  getAllAttendance(
    token: any,
    user: string,
    email?: string,
    month?: string,
    year?: string,
    date?: string,
  ) {
    return http.get(
      `employee/attendance?user=${user}&email=${email || ""}&month=${month || ""}&year=${year || ""}&date=${date || ""}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
  }

  getTodayAttendance(token: any, email: string) {
    return http.get(`employee/attendance/today?email=${email}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getEmployeeAttendanceHistory(
    token: any,
    email: string,
    user: string,
    month?: string,
    year?: string,
  ) {
    return http.get(
      `employee/attendance/history/${email}?user=${user}&month=${month || ""}&year=${year || ""}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
  }

  loginAttendance(token: any, email: string, name: string) {
    return http.post(
      `employee/attendance/login`,
      { email, name },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
  }

  logoutAttendance(token: any, email: string) {
    return http.post(
      `employee/attendance/logout`,
      { email },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
  }

  getAttendanceByDate(token: any, date: string, user: string) {
    return http.get(`employee/attendance/date/${date}?user=${user}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  // ========== ATTENDANCE RULE MASTER ==========
  getActiveAttendanceRule(token: any) {
    return http.get(`employee/config/attendance-rule`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateAttendanceRule(token: any, data: any, user: string) {
    return http.put(`employee/config/attendance-rule?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== ATTENDANCE CORRECTION WORKFLOW ==========
  createAttendanceCorrection(token: any, data: any) {
    return http.post(`employee/attendance/corrections`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getAttendanceCorrections(
    token: any,
    user: string,
    email?: string,
    status?: string,
    mine?: boolean,
  ) {
    return http.get(
      `employee/attendance/corrections?user=${user}&email=${email || ""}&status=${status || ""}${mine ? "&mine=true" : ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  reviewAttendanceCorrection(
    token: any,
    id: string,
    data: any,
    user: string,
  ) {
    return http.patch(
      `employee/attendance/corrections/${id}/status?user=${user}`,
      data,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  // ========== EMPLOYEE MONTHLY CONFIRMATION ==========
  submitEmployeeMonthlyConfirmation(token: any, data: any) {
    return http.post(`employee/monthly-confirmation`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getEmployeeMonthlyConfirmations(
    token: any,
    user: string,
    email?: string,
    month?: string,
    year?: string,
  ) {
    return http.get(
      `employee/monthly-confirmation?user=${user}&email=${email || ""}&month=${month || ""}&year=${year || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  getEmployeeMonthlyConfirmationByMonth(
    token: any,
    month: string,
    year: string,
    user: string,
  ) {
    return http.get(
      `employee/monthly-confirmation/${month}/${year}?user=${user}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  updateEmployeeMonthlyConfirmation(
    token: any,
    id: string,
    data: any,
    user: string,
  ) {
    return http.patch(
      `employee/monthly-confirmation/${id}?user=${user}`,
      data,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  updateSalary(token: any, id: string, data: any, user: string) {
    return http.patch(
      `employee/monthly-confirmation/${id}/salary?user=${user}`,
      data,
      {
        headers: { authorization: `Bearer ${token}` },
      },
    );
  }

  addSalaryDeduction(token: any, id: string, data: any, user: string) {
    return http.patch(
      `employee/monthly-confirmation/${id}/deduction?user=${user}`,
      data,
      {
        headers: { authorization: `Bearer ${token}` },
      },
    );
  }

  // ========== SALARY ==========
  getSalary(
    token: any,
    user: string,
    email?: string,
    month?: string,
    year?: string,
  ) {
    return http.get(
      `employee/salary?user=${user}&email=${email || ""}&month=${month || ""}&year=${year || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  getSalaryByMonth(token: any, month: string, year: string, user: string) {
    return http.get(`employee/salary/${month}/${year}?user=${user}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  createSalary(token: any, data: any, user: string) {
    return http.post(`employee/salary?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // updateSalary(token: any, id: string, data: any, user: string) {
  //   return http.patch(`employee/salary/${id}?user=${user}`, data, {
  //     headers: { authorization: `Bearer ${token}` },
  //   });
  // }

  // addSalaryDeduction(token: any, id: string, data: any, user: string) {
  //   return http.patch(`employee/salary/${id}/deduction?user=${user}`, data, {
  //     headers: { authorization: `Bearer ${token}` },
  //   });
  // }

  // ========== TASKS ==========
  createTask(token: any, data: any) {
    return http.post(`employee/tasks`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getTasks(
    token: any,
    user: string,
    email?: string,
    date?: string,
    month?: string,
    year?: string,
  ) {
    return http.get(
      `employee/tasks?user=${user}&email=${email || ""}&date=${date || ""}&month=${month || ""}&year=${year || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  updateTask(token: any, id: string, data: any) {
    return http.patch(`employee/tasks/${id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== TARGETS ==========
  createTarget(token: any, data: any, user: string) {
    return http.post(`employee/targets?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getTargets(token: any, user: string, email?: string) {
    return http.get(`employee/targets?user=${user}&email=${email || ""}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateTarget(token: any, id: string, data: any) {
    return http.patch(`employee/targets/${id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== APPRAISALS ==========
  createAppraisal(token: any, data: any, user: string) {
    return http.post(`employee/appraisals?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getAppraisals(token: any, user: string, email?: string) {
    return http.get(`employee/appraisals?user=${user}&email=${email || ""}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateAppraisal(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/appraisals/${id}?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== EXIT MANAGEMENT ==========
  initiateExit(token: any, data: any, user: string) {
    return http.post(`employee/exit?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getExitRecords(token: any, user: string, email?: string) {
    return http.get(`employee/exit?user=${user}&email=${email || ""}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateExit(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/exit/${id}?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  submitHandover(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/exit/${id}/handover?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  grantClearance(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/exit/${id}/clearance?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== LEAVE TYPE MASTER ==========
  getLeaveTypes(token: any, includeInactive?: boolean) {
    return http.get(
      `employee/config/leave-types?includeInactive=${includeInactive ? "true" : "false"}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  createLeaveType(token: any, data: any, user: string) {
    return http.post(`employee/config/leave-types?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateLeaveType(token: any, code: string, data: any, user: string) {
    return http.patch(
      `employee/config/leave-types/${code}?user=${user}`,
      data,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  // ========== LEAVE APPROVAL WORKFLOW ==========
  getPendingLeaveApprovals(token: any, approver: string) {
    return http.get(
      `employee/leaves/pending-approvals?approver=${approver}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  advanceLeaveApproval(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/leaves/${id}/approve?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== LEAVE BALANCE / CARRY FORWARD ==========
  getLeaveBalanceLedger(token: any, email: string, user: string) {
    return http.get(`employee/leave-balance/${email}?user=${user}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getTeamLeaveBalanceLedger(token: any, user: string) {
    return http.get(`employee/leave-balance/team?user=${user}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // Annual/used/remaining quota per leave type (not the carry-forward ledger).
  getLeaveTypeBalance(token: any, email: string) {
    return http.get(`employee/leaves/balance?email=${email}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // The same balances for the caller's team (or every employee, with attendance.view.all).
  getTeamLeaveTypeBalance(token: any, user: string) {
    return http.get(`employee/leaves/balance/team?user=${user}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  runLeaveCarryForward(token: any, year: number, user: string) {
    return http.post(
      `employee/leave-balance/run-carry-forward?user=${user}`,
      { year },
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  // ========== DASHBOARD WIDGETS ==========
  getEmployeeDashboardWidgets(token: any, email: string) {
    return http.get(`employee/dashboard/employee?email=${email}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getManagerDashboardWidgets(token: any, email: string) {
    return http.get(`employee/dashboard/manager?email=${email}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getAdminDashboardWidgets(token: any) {
    return http.get(`employee/dashboard/admin`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  setDashboardSpotlight(token: any, data: any, user: string) {
    return http.post(`employee/dashboard/spotlight?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  createDashboardFlag(token: any, data: any, user: string) {
    return http.post(`employee/dashboard/flags?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  resolveDashboardFlag(token: any, id: string, user: string) {
    return http.patch(
      `employee/dashboard/flags/${id}/resolve?user=${user}`,
      {},
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  // ========== ROLE MANAGEMENT (RBAC) ==========
  getRoles(token: any) {
    return http.get(`employee/roles`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getAvailablePermissions(token: any) {
    return http.get(`employee/roles/permissions`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  createRole(token: any, data: any, user: string) {
    return http.post(`employee/roles?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateRole(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/roles/${id}?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== HOLIDAY MASTER ==========
  getHolidays(token: any, year?: string) {
    return http.get(`employee/config/holidays?year=${year || ""}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  createHoliday(token: any, data: any, user: string) {
    return http.post(`employee/config/holidays?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  updateHoliday(token: any, id: string, data: any, user: string) {
    return http.patch(`employee/config/holidays/${id}?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  deleteHoliday(token: any, id: string, user: string) {
    return http.delete(`employee/config/holidays/${id}?user=${user}`, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  // ========== REPORTS ==========
  getAttendanceReport(token: any, month: string, year: string, user: string, email?: string) {
    return http.get(
      `employee/reports/attendance?month=${month}&year=${year}&user=${user}&email=${email || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  exportAttendanceReport(token: any, month: string, year: string, user: string, email?: string) {
    return http.get(
      `employee/reports/attendance/export?month=${month}&year=${year}&user=${user}&email=${email || ""}`,
      {
        headers: { authorization: `Bearer ${token}` },
        responseType: "blob",
      },
    );
  }

  getLeaveReport(token: any, month: string, year: string, user: string, email?: string) {
    return http.get(
      `employee/reports/leave?month=${month}&year=${year}&user=${user}&email=${email || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }

  exportLeaveReport(token: any, month: string, year: string, user: string, email?: string) {
    return http.get(
      `employee/reports/leave/export?month=${month}&year=${year}&user=${user}&email=${email || ""}`,
      {
        headers: { authorization: `Bearer ${token}` },
        responseType: "blob",
      },
    );
  }

  // ========== COMPENSATORY OFF ==========
  grantCompensatoryOff(token: any, data: any, user: string) {
    return http.post(`employee/leaves/compensatory?user=${user}`, data, {
      headers: { authorization: `Bearer ${token}` },
    });
  }

  getCompensatoryOffs(token: any, user: string, email?: string) {
    return http.get(
      `employee/leaves/compensatory?user=${user}&email=${email || ""}`,
      { headers: { authorization: `Bearer ${token}` } },
    );
  }
}

export default new EmployeeService();
